import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../modal/PC/PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../AppStore';
import Swal from "sweetalert2";

// 요일 정의 (PostgreSQL EXTRACT(DOW): 일=0 ~ 토=6)
const WEEK_DEFS = [
  { code: '0', label: '일' },
  { code: '1', label: '월' },
  { code: '2', label: '화' },
  { code: '3', label: '수' },
  { code: '4', label: '목' },
  { code: '5', label: '금' },
  { code: '6', label: '토' },
];

function ProfileModal({ profileModalClose }) {
  const appStore = useContext(AppContext);
  const [bankModalOption, setBankModalOption] = useState([]);
  const [isPhoneDisabled, setIsPhoneDisabled] = useState(false);
  const [inputs, setInputs] = useState({
    user_id:0,
    user_name:'',
    password:'',
    password_confirm: '',
    user_call:'',
    user_email:'',
    user_phone:'',
    bank:'',
    bank_number: '',
    user_note: '',
    app_noti_start_time: '09:00',
    app_noti_end_time: '18:00',
    app_noti_week: '1,2,3,4,5',            // ★ 알림 허용요일 (기본 월~금)
    app_noti_order_yn: 'Y',
    app_noti_purchase_yn: 'Y',
    app_noti_outgoing_yn: 'Y',
    app_noti_incoming_yn: 'Y',
    app_noti_produce_work_yn: 'Y',
    app_noti_machine_yn: 'Y'
  });
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
      //은행
      axios.get('/api/Common/CodeDetailList')
      .then((response) => {

          var bank_array = [];
          for(let i=0; i<(response.data).length; i++){
              if((response.data)[i].code_id === '0006'){
                  bank_array.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
              }
          }
          bank_array.unshift({ value: 0, label : '은행'});

          setBankModalOption(bank_array);
      })
      .catch((error) => {
          console.log(error);
      });

      handleInitSelect();
  }, []);

  useEffect(() => {
      //렌더링 될 때 마다 실행된다.
  });

  const handleInitSelect = () => {
    axios.get('/api/Common/Profile')
    .then((response) => {
      setInputs({
        user_id: response.data.user_id,
        user_name: typeof response.data.user_name === 'undefined'? '':response.data.user_name,
        password:'',
        password_confirm: '',
        user_call: typeof response.data.user_call === 'undefined'? '':response.data.user_call,
        user_email: typeof response.data.user_email === 'undefined'? '':response.data.user_email,
        user_phone: typeof response.data.user_phone === 'undefined'? '':response.data.user_phone,
        bank: typeof response.data.user_account_bank === 'undefined'? '':response.data.user_account_bank,
        bank_number: typeof response.data.user_account_number === 'undefined'? '':response.data.user_account_number,
        user_note: typeof response.data.user_note === 'undefined'? '':response.data.user_note,
        app_noti_start_time: response.data.app_noti_start_time || '09:00',
        app_noti_end_time: response.data.app_noti_end_time || '18:00',
        app_noti_week: response.data.app_noti_week || '1,2,3,4,5',       // ★
        app_noti_order_yn: response.data.app_noti_order_yn || 'Y',
        app_noti_purchase_yn: response.data.app_noti_purchase_yn || 'Y',
        app_noti_outgoing_yn: response.data.app_noti_outgoing_yn || 'Y',
        app_noti_incoming_yn: response.data.app_noti_incoming_yn || 'Y',
        app_noti_produce_work_yn: response.data.app_noti_produce_work_yn || 'Y',
        app_noti_machine_yn: response.data.app_noti_machine_yn || 'Y'
      });
    })
    .catch((error) => {
        console.log(error);
    });
  };

  const ToggleYN = ({ value, onToggle }) => {
    const on = value === 'Y';
    return (
      <div
        onClick={() => onToggle(on ? 'N' : 'Y')}
        style={{
          width: 46, height: 26, borderRadius: 13, display: 'inline-block',
          background: on ? '#4C8DFF' : '#D1D5DB', position: 'relative',
          cursor: 'pointer', transition: 'background .2s', flex: '0 0 auto'
        }}
      >
        <div style={{
          width: 20, height: 20, borderRadius: '50%', background: '#fff',
          position: 'absolute', top: 3, left: on ? 23 : 3,
          transition: 'left .2s', boxShadow: '0 1px 2px rgba(0,0,0,.3)'
        }} />
      </div>
    );
  };

  // ★ 요일 토글: app_noti_week 문자열('1,2,3,4,5')에서 해당 요일 추가/제거
  const toggleWeek = (code) => {
    const set = new Set(
      (inputs.app_noti_week || '')
        .split(',')
        .map(s => s.trim())
        .filter(s => s !== '')
    );
    if (set.has(code)) {
      set.delete(code);
    } else {
      set.add(code);
    }
    // 0~6 순서로 정렬 후 문자열로
    const next = Array.from(set).sort((a, b) => Number(a) - Number(b)).join(',');
    setInputs({ ...inputs, app_noti_week: next });
  };

  const isWeekOn = (code) => {
    return (inputs.app_noti_week || '')
      .split(',')
      .map(s => s.trim())
      .includes(code);
  };

  const onSelectChange = (type, value) => {
    const nextInputs = {
        ...inputs,
        [type] : value
    };
    setInputs(nextInputs);
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value,
    };
    setInputs(nextInputs);
  };

  const onHypenChange = async (e) => {
    const {name, value} = e.target;
    var hyphen_data = ''
    hyphen_data = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
        .replace(/(-{1,2})$/g, "");
    const nextInputs = {
        ...inputs,
        [name]: hyphen_data,
    };
    setInputs(nextInputs);
    if (hyphen_data.match(/010-(\d{4})-(\d{4})/)) {
      Swal.fire({
          title: '휴대폰인증',
          html : hyphen_data + ' 인증번호를 발송 할까요?',
          showCancelButton : true,
          confirmButtonClass : "btn-danger",
          confirmButtonText : "확인",
          cancelButtonText : "취소"
      }).then((result) => {
          if (result.isConfirmed) {
              var returndata = appStore.PHONE_AUTH(hyphen_data);
              if(String(returndata) === 'Y'){
                setIsPhoneDisabled(true);
              }
          }
      });
    }
  };

  const handleSave = () => {
    // 이름 확인 정규식(2-20 자리 영문소+영문대+한글+띄어쓰기 입력 가능) : !(/^[가-힣a-zA-z\s]{2,20}$/).test(inputs.user_name.trim())
    // 날짜 확인 정규식(19@@년도 입력 불가) : !(/^2[0-1]\d{2}-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/).test(inputs.user_start_date.trim())
    // 날짜 확인 정규식(19@@년도 입력 가능) : !(/^(19\d{2}|2[0-1]\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/).test(inputs.user_start_date.trim())
    // 휴대폰 정규식(010-숫자4자리-숫자4자리 입력 가능) : !(/^010-\d{4}-\d{4}$/).test(inputs.user_phone.trim())
    // 전화번호 정규식(숫자3자리-숫자4자리-숫자4자리) : !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.user_call.trim())
    // E-Mail 정규식 : !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.user_email.trim())
    // 계좌번호 정규식(숫자, 하이픈 5-30자리 이하) : !(/^[0-9-]{5,30}$/).test(inputs.bank_number.trim())
    let msg = '';
    if(inputs.user_name.trim() === ''){
      msg = '이름은 필수로 입력 해주세요.';
    }else if(!(/^[가-힣a-zA-z\s]{2,20}$/).test(inputs.user_name.trim())){
      msg = '이름 입력이 올바르지 않습니다.<br/>(입력 양식 : 한글+영문+띄어쓰기 2~20자리)';
    }else if(inputs.user_phone.trim() !== '' && !(/^010-\d{4}-\d{4}$/).test(inputs.user_phone.trim())){
      msg = '휴대폰번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 010-숫자4자리-숫자4자리)';
    }else if(inputs.user_call.trim() !== '' && !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.user_call.trim())){
      msg = '전화번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 숫자3자리-숫자4자리-숫자4자리)';
    }else if(inputs.user_email.trim() !== '' && !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.user_email.trim())){
      msg = 'E-Mail 입력이 올바르지 않습니다.';
    }else if(inputs.bank_number.trim() !== '' && !(/^[0-9-]{5,30}$/).test(inputs.bank_number.trim())){
      msg = '계좌번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 숫자, 하이픈 5자리~30자리)';
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);

      axios.post("/api/Common/ProfileUpdate", new URLSearchParams({
        user_name: inputs.user_name.trim(),
        user_email: inputs.user_email.trim(),
        user_phone: inputs.user_phone.trim(),
        user_call: inputs.user_call.trim(),
        bank: inputs.bank,
        bank_number: inputs.bank_number.trim(),
        user_note: inputs.user_note.trim(),
        app_noti_start_time: inputs.app_noti_start_time,
        app_noti_end_time: inputs.app_noti_end_time,
        app_noti_week: inputs.app_noti_week,                 // ★
        app_noti_order_yn: inputs.app_noti_order_yn,
        app_noti_purchase_yn: inputs.app_noti_purchase_yn,
        app_noti_outgoing_yn: inputs.app_noti_outgoing_yn,
        app_noti_incoming_yn: inputs.app_noti_incoming_yn,
        app_noti_produce_work_yn: inputs.app_noti_produce_work_yn,
        app_noti_machine_yn: inputs.app_noti_machine_yn
     }),
     { withCredentials: true })
     .then(function (response) {
        if (response.status === 200) {

          const pw  = (inputs.password || '').trim();
          const pw2 = (inputs.password_confirm || '').trim();
          const hasPw = (pw !== '' || pw2 !== '');

          // ✅ 비번 입력이 있으면 먼저 검증
          if (hasPw) {
            if (pw === '' || pw2 === '') {
              appStore.setLoading(false);
              Swal.fire({
                title: '<p style="color:red">비밀번호 변경 오류</p>',
                html: '패스워드와 패스워드 확인을 모두 입력해주세요.',
                confirmButtonText: '확인'
              });
              return; // ✅ 완료 팝업/초기화 진행 X
            }
            if (pw !== pw2) {
              appStore.setLoading(false);
              Swal.fire({
                title: '<p style="color:red">비밀번호 변경 오류</p>',
                html: '패스워드와 패스워드 확인을 동일하게 입력해주세요.',
                confirmButtonText: '확인'
              });
              return; // ✅ 완료 팝업/초기화 진행 X
            }
          }

          // ✅ 비번 입력이 있으면 비번 저장 후 완료 처리
          const finishOk = () => {
            Swal.fire({
              title: '프로필 수정 완료',
              text: '정상적으로 프로필이 수정 되었습니다.',
              confirmButtonText: '확인',
              timer: 5000,
              timerProgressBar: true
            }).then(() => {
              handleInitSelect();
            });
          };

          if (hasPw) {
            axios.post("/api/Common/ProfilePWUpdate",
              new URLSearchParams({ password: pw }),
              { withCredentials: true }
            )
            .then(function (pwRes) {
              if (pwRes.status === 200) {
                finishOk(); // ✅ 비번까지 성공하면 여기서 완료
              } else {
                appStore.capture();
              }
            })
            .catch(function () {
              appStore.capture();
            })
            .then(function () {
              appStore.setLoading(false);   // ✅ 추가 (비번쪽 마무리)
            });

          } else {
            // ✅ 비번 입력 없으면 그냥 완료
            finishOk();
          }

        } else {
          appStore.capture();
        }
      })
     .catch(function (error) {
        appStore.capture();
     })
     .then(function () {
        appStore.setLoading(false);
     });
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">프로필 수정 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }
  };

  const handlePWUpdate = () => {
    let msg = '';
    if(inputs.password === '' || inputs.password_confirm === ''){
      msg = '패스워드와 패스워드 확인을 모두 입력해주세요.'
    }else if(inputs.password !== inputs.password_confirm){
      msg = '패스워드와 패스워드 확인을 동일하게 입력해주세요.'
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);
      axios.post("/api/Common/ProfilePWUpdate", new URLSearchParams({
        password: inputs.password
      }),
      { withCredentials: true })
      .then(function (response) {
          appStore.setLoading(false);
          if(response.status === 200){
            Swal.fire({
              title: '비밀번호 변경 완료',
              text: '정상적으로 비밀번호가 변경 되었습니다.',
              confirmButtonText: '확인',
              timer:5000,
              timerProgressBar: true
            }).then((result) => {
              handleInitSelect();
            });
          }else{
            appStore.capture();
          }
      })
      .catch(function (error) {
          appStore.setLoading(false);
          appStore.capture();
      });
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">비밀번호 변경 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }
  };

  return (
    <PCModal onClose={profileModalClose} title={"프로필 수정"}>
        <div className="modal" style={{ height : 'auto', overflowY: 'auto'}}>
          <div>
            <table className="ModalTABLE">
              <tbody>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">이름<span className="essential">*</span></div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="이름" value={inputs.user_name} name="user_name" onChange={(e) => onChange(e) } autoComplete="off" />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">E-mail</div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="E-mail" value={inputs.user_email} name="user_email" onChange={(e) => onChange(e) } autoComplete="off" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">비밀번호</div>
                      <div className="modal_filed_input">
                        <input type="password" placeholder="비밀번호" value={inputs.password} name="password" onChange={(e) => onChange(e) } autoComplete="off" />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">비밀번호 확인</div>
                      <div className="modal_filed_input">
                        <input type="password" placeholder="비밀번호 확인" value={inputs.password_confirm} name="password_confirm" onChange={(e) => onChange(e) } autoComplete="off" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">휴대폰번호</div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="휴대폰번호" value={inputs.user_phone} name="user_phone" onChange={(e) => onHypenChange(e) } autoComplete="off" disabled={isPhoneDisabled} />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">전화번호</div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="전화번호" value={inputs.user_call} name="user_call" onChange={(e) => onChange(e) } autoComplete="off" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">은행</div>
                      <div className="modal_filed_input">
                        <Select className="modal_filed_input_select" placeholder="은행" value={bankModalOption.filter(function (option) { return option.value === inputs.bank;  })} onChange={(e) => onSelectChange('bank',e.value)} options={bankModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">계좌번호</div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="계좌번호" value={inputs.bank_number} name="bank_number" onChange={(e) => onChange(e) } autoComplete="off" />
                      </div>
                    </div>
                  </td>
                </tr>
                {/* ★ 알림 시간 + 알림 요일 — 한 줄(왼쪽 시간 / 오른쪽 요일) */}
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">알림 요일</div>
                      <div className="modal_filed_input" style={{ display: 'flex', gap: 5, paddingTop: 4, flexWrap: 'nowrap' }}>
                        {WEEK_DEFS.map((w) => {
                          const on = isWeekOn(w.code);
                          const isSun = w.code === '0';
                          const isSat = w.code === '6';
                          const offColor = isSun ? '#E34935' : (isSat ? '#2F6FE0' : '#555');
                          return (
                            <div
                              key={w.code}
                              onClick={() => toggleWeek(w.code)}
                              style={{
                                width: 32, height: 32, borderRadius: '50%',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                cursor: 'pointer', userSelect: 'none', fontSize: 13, fontWeight: 600,
                                flex: '0 0 auto',
                                border: on ? '2px solid #4C8DFF' : '2px solid #D1D5DB',
                                background: on ? '#4C8DFF' : '#fff',
                                color: on ? '#fff' : offColor,
                                transition: 'all .15s'
                              }}
                            >
                              {w.label}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">알림 시간</div>
                      <div className="modal_filed_input" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <input type="time" value={inputs.app_noti_start_time} name="app_noti_start_time" onChange={(e) => onChange(e)}
                          style={{ width: 118, height: 30, boxSizing: 'content-box', padding: 5, border: '2px solid lightgrey', borderRadius: 5, outline: 'none', fontSize: 15 }} />
                        <span style={{ fontSize: 15, color: '#555' }}>~</span>
                        <input type="time" value={inputs.app_noti_end_time} name="app_noti_end_time" onChange={(e) => onChange(e)}
                          style={{ width: 118, height: 30, boxSizing: 'content-box', padding: 5, border: '2px solid lightgrey', borderRadius: 5, outline: 'none', fontSize: 15 }} />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">수주</div>
                      <div className="modal_filed_input" style={{ display: 'flex', alignItems: 'center', paddingTop: 8 }}>
                        <ToggleYN value={inputs.app_noti_order_yn} onToggle={(v) => onSelectChange('app_noti_order_yn', v)} />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">발주</div>
                      <div className="modal_filed_input" style={{ display: 'flex', alignItems: 'center', paddingTop: 8 }}>
                        <ToggleYN value={inputs.app_noti_purchase_yn} onToggle={(v) => onSelectChange('app_noti_purchase_yn', v)} />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">출하</div>
                      <div className="modal_filed_input" style={{ display: 'flex', alignItems: 'center', paddingTop: 8 }}>
                        <ToggleYN value={inputs.app_noti_outgoing_yn} onToggle={(v) => onSelectChange('app_noti_outgoing_yn', v)} />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">입고</div>
                      <div className="modal_filed_input" style={{ display: 'flex', alignItems: 'center', paddingTop: 8 }}>
                        <ToggleYN value={inputs.app_noti_incoming_yn} onToggle={(v) => onSelectChange('app_noti_incoming_yn', v)} />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">생산작업</div>
                      <div className="modal_filed_input" style={{ display: 'flex', alignItems: 'center', paddingTop: 8 }}>
                        <ToggleYN value={inputs.app_noti_produce_work_yn} onToggle={(v) => onSelectChange('app_noti_produce_work_yn', v)} />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">설비</div>
                      <div className="modal_filed_input" style={{ display: 'flex', alignItems: 'center', paddingTop: 8 }}>
                        <ToggleYN value={inputs.app_noti_machine_yn} onToggle={(v) => onSelectChange('app_noti_machine_yn', v)} />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_filed">
                      <div className="modal_filed_title">비고</div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="비고" value={inputs.user_note} name="user_note" onChange={(e) => onChange(e) } style={{width: '755px'}} autoComplete="off" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_action">

                      <div className="modal_button" style={{float: 'left'}}>
                        <Button
                          onClick={ handlePWUpdate }
                          className="btn-p btn-u"
                          style={{width: '170px'}}
                          sx={{
                              m: 1,
                              fontSize: 18,
                              color: "white",
                              borderColor: "#0067a3",
                              backgroundColor: "#0067a3",
                              ":hover": { boxShadow: "2px 2px 2px #0067a3" , backgroundColor: "#0067a3", borderColor: "#0067a3"}
                          }}
                          variant="outlined">
                          비밀번호 변경
                        </Button>
                      </div>

                      <div className="modal_button">
                        <Button
                          onClick={()=> { profileModalClose?.(); }}
                          className="btn-p"
                          sx={{
                              m: 1,
                              fontSize: 15,
                              color: "white",
                              borderColor: "#808080",
                              backgroundColor: "#808080",
                              ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                          }}
                          variant="outlined">
                          닫기
                        </Button>
                      </div>
                      <div className="modal_button">
                        <Button
                          onClick={handleSave}
                          className="btn-p btn-u"
                          sx={{
                              m: 1,
                              fontSize: 18,
                              color: "white",
                              borderColor: "#FF3636",
                              backgroundColor: "#FF3636",
                              ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                          }}
                          variant="outlined">
                          수정
                        </Button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </PCModal>
  );
}

export default ProfileModal;
